/* native angular modules */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

/* Angular Material modules, the less we can use, will try remove items from here */
import { MatSidenavModule, MatDialogModule} from '@angular/material';

// loads angular material, but is encapsuled in his own scope, we may keep this one - raw version also in consertion
import { TourMatMenuModule } from 'ngx-tour-md-menu';
/* Custom modules*/
import { AppComponent } from './app.component';

import {
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    AuthLayoutComponent} from './main';

import { SidenavService } from './shared/sidenav/sidenav.service';
import { SharedModule } from './shared/shared.module';
import { CedantModule } from './cedant/cedant.module';
import { ProgramModule } from './program/program.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    AuthLayoutComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatSidenavModule,
    MatDialogModule,
    SharedModule,
    CedantModule,
    ProgramModule,
    TourMatMenuModule.forRoot()
  ],
  providers: [SidenavService],
  bootstrap: [AppComponent]
})
export class AppModule { }
